function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
var scales = require('./scales.json').us;
function specie2mass(specie) {
    var masses = {
        o3: 1.97,
        o3_24: 1.97,
        o3_8: 1.97,
        'o3.v2': 1.97,
        'o3_1.v2': 1.97,
        'o3_8.v2': 1.97,
        no2: 2.026143791,
        so2: 2.82,
        so2_1: 2.82,
        co: 1.23,
    };
    return masses[specie];
}
export function conc2aqi(conc, specie, unit) {
    if (specie === void 0) { specie = 'pm25'; }
    if (unit === void 0) { unit = 'ug/m3'; }
    if (!isNumeric(conc))
        return conc;
    var mapping = {
        'pm10-mg': 'pm10',
        'pm2.5-mg': 'pm25',
    };
    var scale;
    if (mapping[specie])
        specie = mapping[specie];
    // if (specie == 'co' && unit == 'mg/m3') {
    //     unit = 'ug/m3'
    // }
    if (['o3', 'no2', 'so2', 'co', 'o3_8'].indexOf(specie) >= 0) {
        var mass = specie2mass(specie);
        if (unit == 'mg/m3') {
            conc /= mass;
        }
        else if (unit == 'ug/m3') {
            conc = conc / (mass * 1000);
        }
        else if (unit == 'g/m3') {
            conc = (conc * 1000) / mass;
        }
        else if (unit == 'ppb/m3' || unit == 'ppb') {
            conc /= 1000;
        }
        else if (unit == 'ppm/m3' || unit == 'ppm') {
        }
        else {
            return '?' + unit;
        }
    }
    if (['pm25', 'pm10'].indexOf(specie) >= 0) {
        if (unit == 'mg/m3') {
            conc *= 1000;
        }
    }
    if (['no2', 'so2'].indexOf(specie) >= 0) {
        conc *= 1000;
    }
    if (specie == 'pm25')
        scale = scales.pm25;
    else if (specie == 'pm10')
        scale = scales.pm10;
    else if (specie == 'pm1')
        scale = scales.pm25;
    else if (specie == 'co')
        scale = scales.co;
    else if (specie == 'no2')
        scale = scales.no2_24;
    else if (specie == 'so2')
        scale = scales.so2_24;
    else if (specie == 'o3')
        scale = scales.o3_1;
    else if (specie == 'o3_8')
        scale = scales.o3_8;
    else
        return -1;
    var paqi = 0;
    var pconc = 0;
    var o;
    for (var xo in scale) {
        o = scale[xo];
        if (Array.isArray(o)) {
            o = {
                aqi: o[0],
                conc: o[1],
            };
        }
        if (conc <= o.conc || o.aqi == 500) {
            return paqi + ((o.aqi - paqi) * (conc - pconc)) / (o.conc - pconc);
        }
        pconc = o.conc;
        paqi = o.aqi;
    }
    if (!o)
        return -1;
    return o.aqi;
}
